import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';

@JsonObject('model.project.BillAddress')
export class CustomerMemo extends AbstractModel {

    @JsonProperty(String, 'id')
    id?: string;

    @JsonProperty(String, 'value')
    value?: string;
}
